import { articleMetrics, lineKey, requestKey } from './engine.js';
import { normalizeArticle } from './values.js';
export function buildSnapshot(eng, version) {
    const snap = { version, today: eng.today, known: {}, arts: {}, lines: {}, reqs: [], reqItems: {} };
    for (const req of eng.requests) {
        for (const it of req.items)
            snap.known[normalizeArticle(it.art)] = true;
    }
    for (const [a, ag] of Object.entries(eng.arts)) {
        const m = articleMetrics(ag);
        snap.arts[a] = {
            name: ag.name,
            toBuy: m.toBuy,
            demand: ag.demand,
            bought: ag.bought,
            packed: ag.packed,
            packable: m.packable,
            stockLeft: m.stockLeft,
            stockDate: ag.stockDate,
            factoryPrice: ag.factoryPrice,
            hs: ag.hs,
            suggestion: ag.suggestion,
            wattrs: { ...ag.wattrs }
        };
    }
    for (const l of eng.lines) {
        snap.lines[lineKey(l.reqKey, normalizeArticle(l.item.art))] = { demand: l.demand, toBuy: l.toBuy, bought: l.bought };
    }
    for (const req of eng.requests) {
        const key = requestKey(req.no);
        const s = eng.reqSummary[key];
        snap.reqs.push({
            no: req.no,
            key,
            status: s.status,
            created: req.created,
            createdBy: req.createdBy,
            deadline: req.deadline,
            comment: req.comment,
            positions: s.positions,
            qty: s.qty,
            amount: s.amount,
            bought: s.bought,
            done: s.done,
            packable: s.packable
        });
        snap.reqItems[key] = req.items
            .map((it) => normalizeArticle(it.art))
            .filter((a) => !!eng.linesByKey[lineKey(key, a)]);
    }
    return snap;
}
export function findRequest(snap, key) {
    if (!key)
        return null;
    return snap.reqs.find((r) => r.key === key) ?? null;
}
//# sourceMappingURL=snapshot.js.map